module.exports = __webpack_public_path__ + "img/target.a8956112.png";